import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import {
  RoleListRequest,
  RoleListResponse,
  Role,
  RoleCreateRequest,
  RoleUpdateRequest,
  RoleListShortRequest,
  RoleListShortResponse,
} from "./types";

/**
 * List
 */
export const roleListService = (params: RoleListRequest) =>
  RestAPIClient.call<RoleListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

/**
 * List short
 */
export const roleListShortService = (params: RoleListShortRequest) =>
  RestAPIClient.call<RoleListShortResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.ListShort,
    config: {
      requireAuthentication: true,
      params,
    },
  });

/**
 * Detail
 */
export const roleDetailService = (id: number) =>
  RestAPIClient.call<Role>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Detail}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

/**
 * Create
 */
export const roleCreateService = (params: RoleCreateRequest) =>
  RestAPIClient.call<Role>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

/**
 * Update
 */
export const roleUpdateService = (params: RoleUpdateRequest) =>
  RestAPIClient.call<Role>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${params.id}`,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

/**
 * Update status
 */
export const roleUpdateStatusService = ({
  id,
  isActive,
  applicationId,
}: {
  id: number;
  isActive: boolean;
  applicationId: number;
}) =>
  RestAPIClient.call<Role>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${id}/${isActive ? "active" : "inactive"}`,
    config: {
      requireAuthentication: true,
    },
    data: { applicationId },
  });

/**
 * Delete
 */
export const roleDeleteService = (data: {
  id: number;
  applicationId: number;
}) =>
  RestAPIClient.call<Role>({
    method: HTTPRequestMethods.DELETE,
    url: `${Paths.Delete}/${data.id}`,
    config: {
      requireAuthentication: true,
      params: { applicationId: data.applicationId },
    },
  });
